import React from "react";
import Internship from "../components/Jobs/Internship";

function InternshipPage() {
  return (
    <div>
      <Internship />
    </div>
  );
}

export default InternshipPage;
